/* eslint-disable react/jsx-pascal-case */
import { useState } from "react";
import {
  MRT_TableContainer,
  MRT_TableOptions,
  MRT_TablePagination,
  useMaterialReactTable,
} from "material-react-table";
import { TextField, Text } from "@techzyapp/ui-lib";
import { tableIcons } from "./TableIcons";
import {
  columnPinning,
  selectProps,
  rowsPerPageOptions,
  muiCircularProgressProps,
  muiTableBodyCellProps,
  muiTableHeadCellProps,
  renderEmptyRowsFallback,
} from "./TableOptions";

import "./styles.css";

interface LocalTableProps<T extends object> extends MRT_TableOptions<T> {
  loading?: boolean;
  enableSearch?: boolean;
}

const LocalTable = <T extends object>({
  loading = false,
  enableSearch = true,
  ...props
}: LocalTableProps<T>) => {
  const [globalFilter, setGlobalFilter] = useState<string>("");
  const [search, setSearch] = useState<string>("");

  const table = useMaterialReactTable({
    initialState: {
      columnPinning: columnPinning,
      showGlobalFilter: true,
    },
    enableColumnFilterModes: true,
    enableColumnPinning: true,
    enableRowActions: true,
    paginationDisplayMode: "pages",
    muiPaginationProps: {
      SelectProps: selectProps,
      rowsPerPageOptions: rowsPerPageOptions,
    },
    enableFacetedValues: true,
    enableSorting: false,
    muiCircularProgressProps,
    muiTableBodyCellProps,
    muiTableHeadCellProps,
    renderEmptyRowsFallback,
    icons: tableIcons,
    onGlobalFilterChange: setGlobalFilter,
    state: {
      globalFilter,
      isLoading: loading,
    },
    ...props,
  });

  return (
    <div className={table.getPageCount() <= 1 ? "hide-pagination" : ""}>
      {enableSearch && (
        <div className="Mui-tableHeader">
          <div className="Mui-tableHeader-left">
            <TextField
              fullWidth
              placeholder="Search"
              iconButtonName="SearchNormal"
              adornmentPosition="start"
              value={search}
              onIconButtonClick={() => {
                setGlobalFilter(search);
              }}
              onChange={(e) => {
                !e.target.value && setGlobalFilter("");
                setSearch(e.target.value);
              }}
            />
          </div>
          <div className="Mui-tableHeader-right"></div>
        </div>
      )}

      <MRT_TableContainer table={table} />
      {props.data.length && props.data.length > 0 ? (
        <div className="Mui-tableFooter-totalRowsWrapper">
          <Text>Total Rows: {props.data.length.toLocaleString()}</Text>
        </div>
      ) : null}
      <MRT_TablePagination table={table} />
    </div>
  );
};

export default LocalTable;
